import React, { FC, useEffect } from 'react';
import './notification.scss';

interface IProps {
  message: string;
  timeToAutoClose: number;
  action: () => void;
}

const Notification: FC<IProps> = ({ message, timeToAutoClose, action }) => {
  useEffect(() => {
    setTimeout(action, timeToAutoClose);
  }, []);

  return (
    <div className='notification-box'>
      <div dangerouslySetInnerHTML={{ __html: message }}/>
      <button onClick={action}/>
    </div>
  );
};

export default Notification;